import type { AppointmentItem } from './appointments-model'
import type { BookingCapability } from './use-booking-capability'

// The deployed change endpoint (user-management → crm-manager) accepts only
// numeric practice-system appointment ids. Provider-account clinics' rows carry
// NexHealth link ids (nhrlink_v1_…), which no deployed service can confirm or
// cancel yet; that backend is a separate change (2026-10-18).
const CHANGEABLE_APPOINTMENT_ID = /^[1-9][0-9]{0,31}$/

export const PRACTICE_SYSTEM_NOTE =
  'Confirm or cancel this visit in your practice system. The change appears here after the next sync.'

export type AppointmentChangeAvailability =
  | { status: 'available' }
  | { status: 'checking'; message: string }
  | { status: 'unavailable'; message: string }

export function appointmentChangeAvailability(
  appointment: AppointmentItem,
  capability: BookingCapability | undefined,
  hasActionService: boolean
): AppointmentChangeAvailability {
  if (
    !hasActionService ||
    !CHANGEABLE_APPOINTMENT_ID.test(appointment.appointmentId)
  ) {
    return { status: 'unavailable', message: PRACTICE_SYSTEM_NOTE }
  }
  if (!capability || capability.state === 'loading') {
    return {
      status: 'checking',
      message: 'Checking whether this appointment can be changed…',
    }
  }
  return capability.appointmentActionsAllowed
    ? { status: 'available' }
    : { status: 'unavailable', message: PRACTICE_SYSTEM_NOTE }
}
